import React from 'react';

import {Table} from 'react-bootstrap';

const UsersTable = (props) => {
    const users = props.users;
    const rows = users.map(user => {
        return (
            <tr key={user.id}>
                <td>{user.cc}</td>
                <td>{user.domain}</td>
                <td>{user.browserName}</td>
                <td>{user.browserVersion}</td>
                <td>{user.firstSession}</td>
                <td>{user.tag}</td>
                <td>{user.tag1}</td>
                <td>{user.tag2}</td>
                <td>{user.tag3}</td>
                <td>{user.tag4}</td>
                <td>{user.tag5}</td>
            </tr>
        );
    });
    return (

        <Table bordered responsive>
            <thead>
            <tr>
                <th>Country</th>
                <th>Domain</th>
                <th>Browser Name</th>
                <th>Browser Version</th>
                <th>First session</th>
                <th>Tag</th>
                <th>Tag1</th>
                <th>Tag2</th>
                <th>Tag3</th>
                <th>Tag4</th>
                <th>Tag5</th>
            </tr>
            </thead>
            <tbody>
                {rows}
            </tbody>
        </Table>
    );
}

export default UsersTable;


// WEBPACK FOOTER //
// ./src/scenes/Users/components/UsersTable/index.js